/**
 * Client logging. Errors carry a `[hugo]` prefix so browser sessions and Playwright can find them
 * in the console. Never log tokens, cookies or message bodies.
 */
export const log = {
  error: (message: string, details?: unknown) => {
    if (details === undefined) console.error(`[hugo] ${message}`)
    else console.error(`[hugo] ${message}`, details)
  },
  warn: (message: string, details?: unknown) => {
    if (details === undefined) console.warn(`[hugo] ${message}`)
    else console.warn(`[hugo] ${message}`, details)
  },
}

/** Browser notices that arrive as error events but are not errors. */
const BENIGN_ERRORS = [/^ResizeObserver loop/]

/** Report uncaught errors and unhandled rejections with the `[hugo]` prefix. */
export function installGlobalErrorLogging() {
  window.addEventListener('error', (event) => {
    if (BENIGN_ERRORS.some((pattern) => pattern.test(event.message))) return
    log.error(`uncaught: ${event.message}`)
  })
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason instanceof Error ? event.reason.message : String(event.reason)
    log.error(`unhandled rejection: ${reason}`)
  })
}
